export default class Stack {
    constructor () {

        this.id = null
        this.client_id = null
        this.name = ""
        this.pre_paid_credit = 0
        this.pi_monthly_total = 0
        this.auto_bill = true
        this.pi_service = ""
    }
}